module.exports = __webpack_public_path__ + "img/bg-dark.820fe18a.png";